import { defineMessages } from 'react-intl';
import {
  EMPTY_REQUIREMENTS,
  FRAGILE_REQUIREMENTS,
  FOLDABLE_REQUIREMENTS,
  SHIPS_OWN_CONTAINER_REQUIREMENTS,
  EMPTY_PREFERENCE,
  BOX_PREFERENCE,
  BUBBLE_PREFERENCE,
  POLY_PREFERENCE,
  OWN_BOX_PREFERENCE,
} from './constants';

export const packagingOptionsMessages = defineMessages({
  requirementsLabel: {
    defaultMessage: 'Package Requirements',
    id: '52h3eY',
    description: 'Label for package requirements dropdown',
  },
  preferenceLabel: {
    defaultMessage: 'Package Preference',
    id: 'DAOtbJ',
    description: 'Label for package preference dropdown',
  },
  [EMPTY_REQUIREMENTS]: {
    defaultMessage: 'No requirements',
    id: '0Ia5VE',
    description: 'No special packaging requirements',
  },
  [FRAGILE_REQUIREMENTS]: {
    defaultMessage: 'Fragile',
    id: 'PgBI1/',
    description: 'Product is fragile and needs special packaging',
  },
  [FOLDABLE_REQUIREMENTS]: {
    defaultMessage: 'Foldable',
    id: 'EvpLh+',
    description: 'Product can be folded',
  },
  [SHIPS_OWN_CONTAINER_REQUIREMENTS]: {
    defaultMessage: 'Ships in own container',
    id: 'f8Z7e5',
    description: 'Product ships in its own container',
  },
  [EMPTY_PREFERENCE]: {
    defaultMessage: 'Any packaging',
    id: 'QsOSHA',
    description: 'No package preference',
  },
  [BOX_PREFERENCE]: {
    defaultMessage: 'Box',
    id: 'bIZx8e',
    description: 'Box packaging preference',
  },
  [BUBBLE_PREFERENCE]: {
    defaultMessage: 'Bubble mailer',
    id: 'CWJyUV',
    description: 'Bubble mailer packaging preference',
  },
  [POLY_PREFERENCE]: {
    defaultMessage: 'Poly mailer',
    id: 'xYFjUN',
    description: 'Poly mailer packaging preference',
  },
  [OWN_BOX_PREFERENCE]: {
    defaultMessage: 'Own box',
    id: 'dawowT',
    description: 'Ships in own box packaging preference',
  },
});
